/* eslint-disable no-bitwise */
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import qs from 'query-string';
import { isSameOriginURL } from '../../urlHelper';

export const ERROR_TYPE: Record<string, string> = {
  400: '400: 错误请求',
  401: '401: 未授权，请重新登录',
  403: '403: 拒绝访问',
  404: '404: 请求错误，未找到该资源',
  405: '405: 请求方式未允许',
  408: '400: 请求超时',
  500: '500: 服务器端错误',
  501: '501: 网络未实现',
  502: '502: 网络错误',
  503: '503: 服务不可用',
  504: '504: 网络超时',
  505: '505: http版本不支持该请求',
};

export const defaultMessage = '网络异常，请稍后重试';

export interface AxionParams {
  baseURL?: string;
  timeout?: number;
  requestInterceptor?: (config: AxiosRequestConfig) => AxiosRequestConfig;
  responseInterceptor?: (response: AxiosResponse) => AxiosResponse;
}

const createAxios = (params: AxionParams = {}) => {
  const { baseURL = '', timeout = 5000, requestInterceptor, responseInterceptor } = params;
  const instance = axios.create({
    baseURL,
    timeout,
  });

  instance.interceptors.request.use(
    (config) => {
      const { url, baseURL: reqBaseUrl } = config;

      // 同域请求添加 x-requested-with header
      if (isSameOriginURL(url as string, reqBaseUrl)) {
        config.headers!['x-requested-with'] = 'XMLHttpRequest';
      }

      if (config.method === 'get') {
        config.paramsSerializer =
          config.paramsSerializer || ((args) => qs.stringify(args, { arrayFormat: 'index' }));
      }
      // 自定义重写拦截器
      if (requestInterceptor) {
        requestInterceptor(config);
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  instance.interceptors.response.use(
    async (response) => {
      const httpStatusCode = parseInt(`${response.status}`, 10);

      if (responseInterceptor) {
        return responseInterceptor(response);
      }
      if (httpStatusCode === 200) {
        const res = response.data || {};
        // eslint-disable-next-line no-shadow
        const { code, data, status } = res;
        // 兼容，thrift 返回的状态在 status 里，其他接口有可能会外层
        const finalCode = status ? status.code : code;
        if (~[200, 0].indexOf(finalCode)) {
          return data;
        }
        if (~[401, 403].indexOf(finalCode)) {
          return Promise.reject(new Error('拒绝访问'));
        }
      } else {
        return Promise.reject(new Error('请求异常'));
      }
      return Promise.reject(new Error('请求异常'));
    },
    (error) => {
      if (error.message === 'Network Error') {
        return Promise.reject(new Error('网络异常'));
      }
      return Promise.reject(error);
    },
  );
  return instance;
};

export { createAxios };
